import React from 'react';
import UserScoring from '../overview/userScoring';
import { useTitle } from '../../hooks/titleProvider';

const MyGames = () => {
  const { setTitle } = useTitle();
  setTitle('My Games');

  return <UserScoring />;
};

export default MyGames;
